import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { Layout } from 'react-grid-layout';

interface UseUpdateDashboardComponentsPositionProps {
  dashboardId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    Layout
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateDashboardComponentsPosition = ({
  dashboardId,
  options,
}: UseUpdateDashboardComponentsPositionProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateDashboardComponentsPosition', dashboardId],
    mutationFn: (components) => {
      return privateAxios.put(`/dashboards/${dashboardId}`, {
        dashboard: {
          components_attributes: components?.map((component) => ({
            id: component.i,
            start_x: component.x,
            start_y: component.y,
            width: component.w,
            height: component.h,
          })),
        },
      });
    },
    ...options,
  });
}
